import { CSVLABEL } from "../constData/csvColumns";
import { CSVLABEL_ON_TIME } from "../constData/csvColumnsOnTime";
import moment from "moment-timezone";
import i18n from "../translations/i18n";
import {
  defaultFilterPayloadTNT,
  optionalFilterPayloadTNT,
} from "../constData/filterRequestPayload";
import {
  defaultFilterPayloadOTP,
  optionalFilterPayloadOTP,
} from "../constData/filterRequestPayloadOnTimePickup";
import {
  defaultFilterPayloadOTD,
  optionalFilterPayloadOTD,
} from "../constData/filterRequestPayloadOnTimeDelivery";
import {
  defaultFilterPayloadFTC,
  optionalFilterPayloadFTC,
} from "../constData/filterRequestPyaloadFirstTender";
import {
  defaultFilterPayloadCER,
  optionalFilterPayloadCER,
} from "../constData/filterRequestPayloadCER";
import { CSVLABEL_FIRST_TENDER } from "../constData/csvColumnsFirstTender";
import { defaultFilterPayloadLAC } from "../constData/filterRequestPayloadLAC";
import { CSVLABEL_LANE_AWARD } from "../constData/csvColumnLaneAward";
import { CSVLABEL_TRAILER_POOL } from "../constData/csvColumnTrailerPool";
import { defaultFilterPayloadTPC } from "../constData/filterRequestPayloadTPC";
import { DRMT_EXCEL_LABEL } from "../constData/excelColumn";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { 
  CSVLABEL_ARRIVAL_AT_DROP_STOP_CER, 
  CSVLABEL_ARRIVAL_AT_PICK_STOP_CER, 
  CSVLABEL_DEPARTURE_FROM_DROP_STOP_CER, 
  CSVLABEL_DEPARTURE_FROM_PICK_STOP_CER 
} from "../constData/csvColumnsCarrierEventResponse";
import {
  COLUMN_ARRIVAL_AT_DROP_STOP_CER,
  COLUMN_ARRIVAL_AT_PICK_STOP_CER,
  COLUMN_DEPARTURE_FROM_DROP_STOP_CER,
  COLUMN_DEPARTURE_FROM_PICK_STOP_CER
} from "../constData/columnsCarrierEventResponse";

const pageSize = 30;
const defaultFilter = 'defaultFilter';
const commentLimit = 500;
const commentsFeature = "CP_TNT_LOAD_COMMENTS";
const dateFormat = "DD-MM-yyyy";
const dateFormat1 = "yyyy-MM-DD";
const datetimeFormats = {
  startTime: "YYYY-MM-DD [00:00:00.000]",
  endTime: "YYYY-MM-DD [23:59:59.999]",
};
const globalFiltersRequired = [
  "deliveryActualArrivalDatetimeFinalDestTZ",
  "isPickedByPrimaryList",
  "carrierid",
  "tariffServiceCodeList",
  "originCityStateList",
  "tenderedToPrimaryList",
];
const globalFilters = {
  originCityStateList: "[]",
  tariffServiceCodeList: "[]",
  carrierid: "[]",
  tenderedToPrimaryList: "[]",
  deliveryActualArrivalDatetimeFinalDestTZ: JSON.stringify({
    startTime: moment().startOf("month").format(dateFormat),
    endTime: moment().format(dateFormat),
  }),
};
const renderRowComponentRestriction = [
  "firstTenderCompliance",
  "laneAwardCompliance",
  "trailerPoolCompliance",
  "carrierEventResponsePick",
  "carrierEventResponseDrop",
];
const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const absolutePaths = {
  onTimePickup: "/dashboard/performance/:carrierid/onTimePickup",
  default: "/dashboard/performance/:carrierid",
  onTimeDelivery: "/dashboard/performance/:carrierid/onTimeDelivery",
  firstTenderCompliance:
    "/dashboard/performance/:carrierid/firstTenderCompliance",
  laneAwardCompliance: "/dashboard/performance/:carrierid/laneAwardCompliance",
  trailerPoolCompliance:
    "/dashboard/performance/:carrierid/trailerPoolCompliance",
};

const restrictedFilterChips = [
  "region", // when we add the option of multiple regions we need to update this condition
  "searchType",
  "returnOnlyTmsPlannedShipments",
];
const carrierRestrictedFilters = [
  "shipmentNumList",
  // "carrierCodeList",
  "carrierDescList",
  "sentToSAP",
  "tmsInSync",
];
const carrierRoles = [
  "ct_carrier_portal_ebam_write_dev",
  "ct_carrier_portal_ebam_write_qa",
  "ct_carrier_portal_ebam_write_prod",
];

const carrierAndAnlystRoles = [
  "ct_carrier_portal_ebam_write_dev",
  "ct_carrier_portal_ebam_write_qa",
  "ct_carrier_portal_ebam_write_prod",

  "ct_carrier_portal_kc_read_dev",
  "ct_carrier_portal_kc_read_qa",
  "ct_carrier_portal_kc_read_prod",

  "ct_carrier_portal_kc_write_dev",
  "ct_carrier_portal_kc_write_qa",
  "ct_carrier_portal_kc_write_prod",
];

const tmtRoles = [
  "ct_carrier_portal_tmt_read_dev",
  "ct_carrier_portal_tmt_read_qa",
  "ct_carrier_portal_tmt_read_prod",

  "ct_carrier_portal_tmt_write_dev",
  "ct_carrier_portal_tmt_write_qa",
  "ct_carrier_portal_tmt_write_prod",
];

const restrictedReasonCodes = ["APC_", "APH_", "AANA", "ABNS", "ABNA"];
const lanes = ["all_lanes", "awarded_lanes", "non_awarded_lanes"];

const restrictedColumnsPerformance = ["pending_task", "time_left"];
const eventType = {
  carrier_actual_delivery_reason_code: "Actual Arrive Dest",
  carrier_actual_pickup_reason_code: "Actual Arrive Origin",
  carrier_actual_delivery_depart_reason_code: "Actual Depart Dest",
  carrier_actual_pickup_depart_reason_code: "Actual Depart Origin",
  planned_appt_reason_code: "Planned Arrive Dest",
  pickup_appt_reason_code: "Planned Arrive Origin",
};
const csvColumnMapping = {
  trackNtrace: CSVLABEL,
  onTimePickup: CSVLABEL_ON_TIME,
  onTimeDelivery: CSVLABEL_ON_TIME,
  firstTenderCompliance: CSVLABEL_FIRST_TENDER,
  laneAwardCompliance: CSVLABEL_LANE_AWARD,
  trailerPoolCompliance: CSVLABEL_TRAILER_POOL,
};

const getCarrierEventResponseConfig = (eventType, csvMapping = false) => {
        if (!eventType) return csvMapping ? CSVLABEL_ARRIVAL_AT_PICK_STOP_CER : COLUMN_ARRIVAL_AT_PICK_STOP_CER;
        
        switch(eventType) {
            case 'arrival_at_pickstop':
                return csvMapping ? CSVLABEL_ARRIVAL_AT_PICK_STOP_CER : COLUMN_ARRIVAL_AT_PICK_STOP_CER;
            case 'departure_from_pickstop':
                return csvMapping ? CSVLABEL_DEPARTURE_FROM_PICK_STOP_CER : COLUMN_DEPARTURE_FROM_PICK_STOP_CER;
            case 'arrival_at_dropstop':
                return csvMapping ? CSVLABEL_ARRIVAL_AT_DROP_STOP_CER : COLUMN_ARRIVAL_AT_DROP_STOP_CER;
            case 'departure_from_dropstop':
                return csvMapping ? CSVLABEL_DEPARTURE_FROM_DROP_STOP_CER : COLUMN_DEPARTURE_FROM_DROP_STOP_CER;
            default:
                return csvMapping ? CSVLABEL_ARRIVAL_AT_PICK_STOP_CER : COLUMN_ARRIVAL_AT_PICK_STOP_CER;
        }
    }

const responseConstList = ["CUST", "STO", "VENDOR_INBOUND"];

const restrictedPages = [
  "fourKitesTracking",
  "billingAccuracy",
];

const stringToArray = (input, filterKey) => {
  let makeArray = [];
  if (input) {
    if (
      [
        "shipmentNumList",
        "carrierCodeList",
        "equipmentTypeList",
        "tariffServiceCodeList",
        "trailerNumList",
        "originStateList",
        "destStateList",
      ].includes(filterKey)
    ) {
      makeArray = input
        .split(/,| /)
        .filter((el) => el !== "")
        .map((item) => item.trim());
    } else {
      makeArray = input
        .split(",")
        .filter((el) => el !== "")
        .map((item) => item.trim());
    }
  }
  return makeArray;
};

const getEnumValue = (value, enumObj, filterLabel) => {
  if (filterLabel === "tm_load_status" && value === "In Transit") {
    return "In Transit";
  }
  return enumObj[value];
};

const toHoursAndMinutes = (totalMinutes, onlyHours = false) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (onlyHours) {
    return totalMinutes ? `${hours}` : "0";
  } else {
    return totalMinutes
      ? `${hours}hrs${minutes > 0 ? ` ${minutes}mins` : " 00mins"}`
      : "00hrs 00mins";
  }
};

const roleSpecificColumns = (columns, role) => {
  if (carrierRoles.includes(role)) {
    return columns.filter(
      (item) => item.Header !== "sent_to_SAP" && item.Header !== "tms_in_sync"
    );
  }
  return columns;
};

const rejectNoResponseRestricted = [
  "service",
  "trailer_number",
  "live_load",
  "pickup_appt_date_time",
  "delivery_appt_date_time",
  "carrier_id",
  "carrier_desc",
  "service_desc",
];

const isJsonParsable = (string) => {
  let parsed = null;
  try {
    parsed = JSON.parse(string);
  } catch (e) {
    return false;
  }
  return parsed;
};

const generateGlobalFilters = (filterKeysArray, filters) => {
  let values = {};
  filterKeysArray.map((d) => {
    values[d] = isJsonParsable(filters[d]) || filters[d];
    if (d === "deliveryActualArrivalDatetimeFinalDestTZ") {
      values[d] = {
        startTime: moment(values[d]?.startTime, dateFormat).format(
          datetimeFormats.startTime
        ),
        endTime: moment(values[d]?.endTime, dateFormat).format(
          datetimeFormats.endTime
        ),
      };
    }
  });
  return values;
};

const generateTableFilters = (
  defaultFilterPayload,
  search,
  filterBody,
  tableName
) => {
  //Search  = Query params URL Values
  //defaultpayload : paylod we have defined
  //filterbody = Schema of filters
  let values = {};
  let definedValues = {};
  Object.keys(defaultFilterPayload).map((d) => {
    values[d] = isJsonParsable(search[d]) || search[d];
    if (filterBody[d]?.stringToArray && search[d] !== "[]") {
      values[d] = stringToArray(search[d], d);
    }
    if (
      filterBody[d]?.type === "date" &&
      values[d]?.startTime &&
      values[d]?.endTime
    ) {
      values[d] = {
        startTime: values[d].startTime,
        endTime: values[d].endTime,
      };
    }
    if (filterBody[d]?.type === "date" && !values[d]) {
      values[d] = null;
    }
    if (tableName === "trackNtrace" && d === "tmsShipmentStatus") {
      if (values[d]?.length === 0) {
        values[d] = [
          "Tender Accepted",
          "Confirming",
          "In Transit",
          "Completed",
        ];
      }
    }
    if (tableName === "firstTenderCompliance" && d === "tenderStatusList") {
      if (values[d]?.length === 0) {
        values[d] = [
          "TENDER_ACCEPTED",
          "TENDER_REJECTED",
          "TENDER_NO_RESPONSE",
        ];
      }
    }
    if (values[d]) {
      definedValues[d] = values[d];
    }
  });
  return { tableFilters: values, definedValues };
};

const optionalFiltersByTable = {
  trackNtrace: optionalFilterPayloadTNT,
  onTimePickup: optionalFilterPayloadOTP,
  onTimeDelivery: optionalFilterPayloadOTD,
  firstTenderCompliance: optionalFilterPayloadFTC,
  carrierEventResponse: optionalFilterPayloadCER,
};

const defaultHeaderFiltersByTable = {
  trackNtrace: defaultFilterPayloadTNT,
  onTimePickup: defaultFilterPayloadOTP,
  onTimeDelivery: defaultFilterPayloadOTD,
  firstTenderCompliance: defaultFilterPayloadFTC,
  laneAwardCompliance: defaultFilterPayloadLAC,
  trailerPoolCompliance: defaultFilterPayloadTPC,
  carrierEventResponse: defaultFilterPayloadCER,
};

const isSubset = (parentArray, subsetArray) => {
  return subsetArray.every((el) => {
    return parentArray.includes(el);
  });
};

const getFloatValue = (divident, divisor, fixed = 1) => {
  let value = parseFloat((divident / divisor) * 100).toFixed(fixed);
  return value;
};

const shouldDisableDate = (day) => {
  if (!day) return false;
  const oneYearAgo = new Date();
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
  return day < oneYearAgo;
};
//------------------DRMT UTILITY FUNCTION--------------------

//--------DRMT DEFAULT CUSTOMIZED COLUMN BID-------
const DEFAULT_COMMON_COLUMN_VIEW = {
  viewName: "default",
  viewCategory: "daily/bid",
  columns: [
    { columnName: "carrierScac", columnNumber: 1 },
    { columnName: "serviceScac", columnNumber: 2 },
    { columnName: "tariffNumber", columnNumber: 3 },
    { columnName: "tariffId", columnNumber: 4 },
    { columnName: "orgHub", columnNumber: 5 },
    { columnName: "originZone", columnNumber: 6 },
    { columnName: "originZoneDesc", columnNumber: 7 },
    { columnName: "originZoneShortDesc", columnNumber: 8 },
    { columnName: "originCity", columnNumber: 9 },
    { columnName: "originState", columnNumber: 10 },
    { columnName: "originCountry", columnNumber: 11 },
    { columnName: "destHub", columnNumber: 12 },
    { columnName: "destinationZone", columnNumber: 13 },
    { columnName: "destinationZoneDesc", columnNumber: 14 },
    { columnName: "destinationZoneShortDesc", columnNumber: 15 },
    { columnName: "destinationCity", columnNumber: 16 },
    { columnName: "destinationState", columnNumber: 17 },
    { columnName: "destinationCountry", columnNumber: 18 },
    { columnName: "region", columnNumber: 19 },
    { columnName: "carrierManager", columnNumber: 20 },
    { columnName: "miles", columnNumber: 21 },
    { columnName: "orderType", columnNumber: 22 },
    { columnName: "laneServiceType", columnNumber: 23 },
    { columnName: "primaryCustomers", columnNumber: 24 },
    { columnName: "preAwarded", columnNumber: 25 },
    { columnName: "equipmentType", columnNumber: 26 },
    { columnName: "laneDescription", columnNumber: 27 },
    { columnName: "lineHaulChargeType", columnNumber: 28 },
    { columnName: "btfRate", columnNumber: 29 },
    { columnName: "lineHaulRate", columnNumber: 30 },
    { columnName: "awardBackup", columnNumber: 31 },
    { columnName: "effectiveDate", columnNumber: 32 },
    { columnName: "expirationDate", columnNumber: 33 },
    { columnName: "bucketType", columnNumber: 34 },
    { columnName: "qtyActiveFlag", columnNumber: 35 },
    { columnName: "qtyStartDate", columnNumber: 36 },
    { columnName: "qtyEndDate", columnNumber: 37 },
    { columnName: "minShipmentsAllocated", columnNumber: 38 },
    { columnName: "maxShipmentsAllocated", columnNumber: 39 },
    { columnName: "percentageActiveFlag", columnNumber: 40 },
    { columnName: "pctStartDate", columnNumber: 41 },
    { columnName: "pctEndDate", columnNumber: 42 },
    { columnName: "minCarrierAllocationPercentage", columnNumber: 43 },
    { columnName: "maxCarrierAllocationPercentage", columnNumber: 44 },
    { columnName: "modeOfTransport", columnNumber: 45 },
    { columnName: "status", columnNumber: 46 },
    { columnName: "bidFileName", columnNumber: 47 },
    { columnName: "changeComment", columnNumber: 48 },
    { columnName: "errors", columnNumber: 49 },
    { columnName: "rate", columnNumber: 50 },
    { columnName: "qtyBucketType", columnNumber: 51 },
    { columnName: "pctBucketType", columnNumber: 52 },
    { columnName: "systemRateId", columnNumber: 53 },
  ],
};

//--------DRMT DEFAULT CUSTOMIZED COLUMN BID-------
const DEFAULT_COLUMN_VIEW_NEW_BID = {
  viewName: "default",
  viewCategory: "Bid",
  columns: [
    { columnName: "carrierScac", columnNumber: 1 },
    { columnName: "serviceScac", columnNumber: 2 },
    { columnName: "tariffNumber", columnNumber: 3 },
    { columnName: "tariffId", columnNumber: 4 },
    { columnName: "orgHub", columnNumber: 5 },
    { columnName: "originZone", columnNumber: 6 },
    { columnName: "originZoneDesc", columnNumber: 7 },
    { columnName: "originZoneShortDesc", columnNumber: 8 },
    { columnName: "originCity", columnNumber: 9 },
    { columnName: "originState", columnNumber: 10 },
    { columnName: "originCountry", columnNumber: 11 },
    { columnName: "destHub", columnNumber: 12 },
    { columnName: "destinationZone", columnNumber: 13 },
    { columnName: "destinationZoneDesc", columnNumber: 14 },
    { columnName: "destinationZoneShortDesc", columnNumber: 15 },
    { columnName: "destinationCity", columnNumber: 16 },
    { columnName: "destinationState", columnNumber: 17 },
    { columnName: "destinationCountry", columnNumber: 18 },
    { columnName: "region", columnNumber: 19 },
    { columnName: "carrierManager", columnNumber: 20 },
    { columnName: "miles", columnNumber: 21 },
    { columnName: "laneServiceType", columnNumber: 22 },
    { columnName: "primaryCustomers", columnNumber: 23 },
    // { columnName: "preAwarded", columnNumber: 24 },
    { columnName: "equipmentType", columnNumber: 25 },
    { columnName: "laneDescription", columnNumber: 26 },
    { columnName: "lineHaulChargeType", columnNumber: 27 },
    // { columnName: "btfRate", columnNumber: 28 },
    { columnName: "lineHaulRate", columnNumber: 29 },
    { columnName: "awardBackup", columnNumber: 30 },
    { columnName: "effectiveDate", columnNumber: 31 },
    { columnName: "expirationDate", columnNumber: 32 },
    { columnName: "bucketType", columnNumber: 33 },
    { columnName: "qtyActiveFlag", columnNumber: 34 },
    { columnName: "minShipmentsAllocated", columnNumber: 35 },
    { columnName: "maxShipmentsAllocated", columnNumber: 36 },
    { columnName: "percentageActiveFlag", columnNumber: 37 },
    { columnName: "maxCarrierAllocationPercentage", columnNumber: 38 },
    { columnName: "modeOfTransport", columnNumber: 39 },
    { columnName: "status", columnNumber: 40 },
    { columnName: "bidFileName", columnNumber: 41 },
    { columnName: "changeComment", columnNumber: 42 },
    { columnName: "defaultError", columnNumber: 43 },
    { columnName: "systemRateId", columnNumber: 44 },
    // { columnName: "errors", columnNumber: 44 },

  ],
};

//--------DRMT DEFAULT CUSTOMIZED COLUMN DAILY-------
const DEFAULT_COLUMN_VIEW_NEW_DAILY = {
  viewName: "default",
  viewCategory: "Daily",
  columns: [
    { columnName: "carrierScac", columnNumber: 1 },
    { columnName: "serviceScac", columnNumber: 2 },
    { columnName: "tariffNumber", columnNumber: 3 },
    { columnName: "tariffId", columnNumber: 4 },
    { columnName: "orgHub", columnNumber: 5 },
    { columnName: "originZone", columnNumber: 6 },
    { columnName: "originZoneDesc", columnNumber: 7 },
    { columnName: "originZoneShortDesc", columnNumber: 8 },
    { columnName: "originCity", columnNumber: 9 },
    { columnName: "originState", columnNumber: 10 },
    { columnName: "originCountry", columnNumber: 11 },
    { columnName: "destHub", columnNumber: 12 },
    { columnName: "destinationZone", columnNumber: 13 },
    { columnName: "destinationZoneDesc", columnNumber: 14 },
    { columnName: "destinationZoneShortDesc", columnNumber: 15 },
    { columnName: "destinationCity", columnNumber: 16 },
    { columnName: "destinationState", columnNumber: 17 },
    { columnName: "destinationCountry", columnNumber: 18 },
    { columnName: "region", columnNumber: 19 },
    { columnName: "carrierManager", columnNumber: 20 },
    { columnName: "miles", columnNumber: 21 },
    { columnName: "orderType", columnNumber: 22 },
    { columnName: "primaryCustomers", columnNumber: 23 },
    
    // { columnName: "preAwarded", columnNumber: 24 },
    { columnName: "equipmentType", columnNumber: 25 },
    { columnName: "laneDescription", columnNumber: 26 },
    { columnName: "lineHaulChargeType", columnNumber: 27 },
    { columnName: "btfRate", columnNumber: 28 },
    { columnName: "rate", columnNumber: 29 },
    // { columnName: "lineHaulRate", columnNumber: 29 },
    { columnName: "awardBackup", columnNumber: 30 },
    { columnName: "effectiveDate", columnNumber: 31 },
    { columnName: "expirationDate", columnNumber: 32 },
    // { columnName: "bucketType", columnNumber: 33 },
    { columnName: "qtyBucketType", columnNumber: 33 },
    
    { columnName: "qtyActiveFlag", columnNumber: 34 },
    // { columnName: "qtyStartDate", columnNumber: 35 },
    // { columnName: "qtyEndDate", columnNumber: 36 },
    { columnName: "minShipmentsAllocated", columnNumber: 37 },
    { columnName: "maxShipmentsAllocated", columnNumber: 38 },
    { columnName: "pctBucketType", columnNumber: 39 },
    { columnName: "percentageActiveFlag", columnNumber: 39 },
    // { columnName: "pctStartDate", columnNumber: 40 },
    // { columnName: "pctEndDate", columnNumber: 41 },
    { columnName: "maxCarrierAllocationPercentage", columnNumber: 42 },
    // { columnName: "pctAward", columnNumber: 42 },
    { columnName: "modeOfTransport", columnNumber: 43 },
    { columnName: "status", columnNumber: 44 },
    // { columnName: "bidFileName", columnNumber: 45 },
    { columnName: "changeComment", columnNumber: 46 },
    // { columnName: "errors", columnNumber: 47 },
    { columnName: "defaultError", columnNumber: 47 },
    { columnName: "systemRateId", columnNumber: 48 },
    
  ],
};

const defaultColumnHeaders = {
  bid: DEFAULT_COLUMN_VIEW_NEW_BID,
  daily: DEFAULT_COLUMN_VIEW_NEW_DAILY,
};

const TABLE_NAME = {
  carrierScac: "Carrier",
  serviceScac: "Service",
  tariffNumber: "Tariff No",
  tariffId: "Tariff ID",
  orgHub: "Org Hub",
  originZone: "Org Zone",
  originZoneDesc: "Org Zone Desc",
  originZoneShortDesc: "Org Zone Short Desc",
  originCity: "Org City",
  originState: "Org State",
  originCountry: "Org Cntry",
  destHub: "Dest Hub",
  destinationZone: "Dest Zone",
  destinationZoneDesc: "Dest Zone Desc",
  DestinationZoneShortDesc: "Dest Zone Short Desc",
  destinationCity: "Dest City",
  destinationState: "Dest State",
  destinationCountry: "Dest Cntry",
  region: "Region",
  carrierManager: "Carrier Manager",
  miles: "Miles",
  orderType: "Order Type",
  laneServiceType: "Order Type",
  primaryCustomers: "Primary Customer",
  preAwarded: "Pre-Awarded",
  equipmentType: "Equip Type",
  laneDescription: "Lane Description",
  lineHaulChargeType: "Charge ID",
  btfRate: "BTF Rate",
  lineHaulRate: "Base Rate",
  awardBackup: "Award/Backup",
  effectiveDate: "Effective Date",
  expirationDate: "Expiration Date",
  bucketType: "Bucket Type",
  qtyActiveFlag: "Qty Active Flag",
  qtyStartDate: "Qty Start Date",
  qtyEndDate: "Qty End Date",
  minShipmentsAllocated: "Min Qty Award",
  maxShipmentsAllocated: "Max Qty Award",
  percentageActiveFlag: "Pct Active Flag",
  pctStartDate: "Pct Start Date",
  pctEndDate: "Pct End Date",
  minCarrierAllocationPercentage: "Pct Award",
  maxCarrierAllocationPercentage: "Pct Award",
  modeOfTransport: "Mode",
  status: "Status",
  bidFileName: "Bid File Name",
  changeComment: "Change Comments",
  coupaFileRecordErrors: "Errors",
  errors: "Errors",
  defaultError: "Errors",
  fileSize: "File Size",
  userId: "User Name",
  rate: "Base Rate",
  fileName: "File Name",
  fileNames: "File Name",
  systemRateId: "Rate ID",
};

const ACTIVE_FLAG = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "Null", value: "-" }
];

const DOWNLOADED_FLAG = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

const BUCKET_TYPE = [
  { label: "Daily", value: "Daily" },
  { label: "Weekly", value: "Weekly" },
  { label: "Monthly", value: "Monthly" },
  { label: "Null", value: "-" }
];

const AWARD_BACKUP_TYPE = [
  { label: "Award", value: "Award" },
  { label: "Backup", value: "Backup" },
  { label: "Null", value: "-" }
];

const REGION = [
  { label: "Canada", value: "Canada" },
  { label: "Mexico", value: "Mexico" },
  { label: "Northeast", value: "Northeast" },
  { label: "Southeast", value: "Southeast" },
  { label: "West", value: "West" },
  { label: "Null", value: "-" }
];

const CARRIER_MANAGER = [
  { label: "Eric Mailahn", value: "Eric Mailahn" },
  { label: "Jenny Shiflett", value: "Jenny Shiflett" },
  { label: "John Hook", value: "John Hook" },
  { label: "Charles Fortner", value: "Charles Fortner" },
  { label: "Matt Harris", value: "Matt Harris" },
  { label: "Landon Foster", value: "Landon Foster" },
  { label: "Null", value: "-" }
];

const ORDER_TYPE = [
  { label: "CUSTOMER", value: "CUSTOMER" },
  { label: "INTERMILL", value: "INTERMILL" },
  { label: "RF-INBOUND", value: "RF-INBOUND" },
  { label: "RM-INBOUND", value: "RM-INBOUND" },
  { label: "RETURNS", value: "RETURNS" },
  { label: "Null", value: "-" }
];

const PRE_AWARD = [
  { label: "N", value: "N" },
  { label: "Y", value: "Y" },
  { label: "Null", value: "-" }
];

const STATUS = [
  "TMS record",                    // code -1
  "Ready to process",              // code 0
  "Pre-validation failed",         // code 3
  "Submit to TM",                  // code 4
  "Error",                         // code 6
  "Request submitted to create Rate",  // code 7
  "Rate creation failed",          // code 8
  "Rate creation success",         // code 9
  "Request submitted to create Lane",// code 10
  "Lane creation success",         // code 11
  "Lane creation failed",          // code 12
  "Ready to expire rate",          // code 13
  "Rate expire success",           // code 14
  "Rate expire failed",            // code 15
  "Rate update request",           // code 16
  "Rate update success",           // code 17
  "Rate update failed",            // code 18
  "Request submitted to expire rate", // code 19
  "TMS success"                    // code 200
];

const CATEGORY = [ 'OCEAN', 'DOMESTIC', 'Null']

const STATUSCODE = [
  {
    code: -3,
    message: "Duplicated record",
  },
  {
     code: -2,
     message: "New record",
  },
  {
    code: -1,
    message: "TMS record",
  },
  {
    code: 0,
    message: "Ready to process",
  },
  {
    code: 3,
    message: "Pre-validation failed",
  },
  {
    code: 4,
    message: "Submit to TM",
  },
  // {
  //   code: 5,
  //   message: "Map the tariff details",
  // },
  {
    code: 6,
    message: "Error",
  },
  {
    code: 7,
    message: "Request submitted to create Rate",
  },
  {
    code: 8,
    message: "Rate creation failed",
  },
  {
    code: 9,
    message: "Rate creation success",
  },
   {
    code: 10,
    message: "Request submitted to create Lane",
  },
  {
    code: 11,
    message: "Lane creation success",
  },
  {
    code: 12,
    message: "Lane creation failed",
  },
  {
    code: 13,
    message: "Ready to expire rate",
  },
  {
    code: 14,
    message: "Rate expire success",
  },
  {
    code: 15,
    message: "Rate expire failed",
  },
   {
    code: 16,
    message: "Rate update request",
  },
  {
    code: 17,
    message: "Rate update success",
  },
  {
    code: 18,
    message: "Rate update failed",
  },
  {
    code: 19,
    message: "Request submitted to expire rate",
  },
  {
    code: 200,
    message: "TMS success",
  },
];

const ADD_RECORD = {
  carrierScac: null,
  serviceScac: null,
  tariffNumber: null,
  tariffId: null,
  orgHub: null,
  originZone: null,
  originZoneDesc: null,
  originZoneShortDesc: null,
  originCity: null,
  originState: null,
  originCountry: null,
  destHub: null,
  destinationZone: null,
  destinationZoneDesc: null,
  destinationZoneShortDesc: null,
  destinationCity: null,
  destinationState: null,
  destinationCountry: null,
  region: null,
  carrierManager: null,
  miles: null,
  orderType: null,
  primaryCustomers: null,
  equipmentType: null,
  laneDescription: null,
  lineHaulChargeType: null,
  btfRate: null,
  rate: null,
  lineHaulRate: null,
  awardBackup: null,
  effectiveDate: null,
  expirationDate: null,
  bucketType: null,
  qtyActiveFlag: null,
  qtyStartDate: null,
  qtyEndDate: null,
  minShipmentsAllocated: null,
  maxShipmentsAllocated: null,
  percentageActiveFlag: null,
  pctStartDate: null,
  pctEndDate: null,
  minCarrierAllocationPercentage: null,
  maxCarrierAllocationPercentage: null,
  modeOfTransport: null,
  status: -2,
  bidFileName: null,
  changeComment: null,
  message: 'New Record',
  coupaFileRecordErrors: [],
  error: [],
  qtyBucketType: null,
  pctBucketType: null,
  defaultError: null,
  systemRateId: null,
};


const formatToMMDDYYYY = (dateStr) => {
  const date = new Date(dateStr + "T00:00:00");
  if (!date || isNaN(date)) return "";
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

const parseFromDDMMYYYY = (value) => {
  const [dd, mm, yyyy] = value.split("/");
  if (dd && mm && yyyy) {
    const parsed = new Date(`${yyyy}-${mm}-${dd}`);
    return parsed instanceof Date && !isNaN(parsed)
      ? parsed.toISOString()
      : undefined;
  }
  return undefined;
};

const convertToDDMMYYYY = (value) => {
  const [dd, mm, yyyy] = value.split("/");
  return `${dd}-${mm}-${yyyy}`;
};

const convertToYYYYDDMM = (value) => {
  const [dd, mm, yyyy] = value.split("/");
  return `${yyyy}-${dd}-${mm}`;
};

const convertToMMDDYYYY = (value) => {
  const [dd, mm, yyyy] = value.split("-");
  return `${dd}/${mm}/${yyyy}`;
};

const reorderColumns = (columnHeaders, columnName, direction) => {
  const moveColumn = (headers, columnName, direction) => {
    const index = headers.findIndex((col) => col.columnName === columnName);
    if (index === -1) return headers;

    const newHeaders = [...headers];

    if (direction === "up" && index > 0) {
      [newHeaders[index - 1], newHeaders[index]] = [
        newHeaders[index],
        newHeaders[index - 1],
      ];
    } else if (direction === "down" && index < newHeaders.length - 1) {
      [newHeaders[index + 1], newHeaders[index]] = [
        newHeaders[index],
        newHeaders[index + 1],
      ];
    }

    // Recalculate columnNumber after reordering
    return newHeaders.map((col, i) => ({
      ...col,
      columnNumber: i + 1,
    }));
  };

  const { defaultHeader, customHeaders } = columnHeaders;

  const bookmarkedHeaderObj = customHeaders?.find((h) => h.bookMarked);

  if (bookmarkedHeaderObj && Array.isArray(bookmarkedHeaderObj.columns)) {
    const updatedCustomHeaders = customHeaders.map((headerObj) => {
      if (headerObj.bookMarked) {
        return {
          ...headerObj,
          columns: moveColumn(headerObj.columns, columnName, direction),
        };
      }
      return headerObj;
    });

    return {
      ...columnHeaders,
      customHeaders: updatedCustomHeaders,
    };
  }

  return {
    ...columnHeaders,
    defaultHeader: moveColumn(defaultHeader, columnName, direction),
  };
};

const orderHeaderArray = (defaultHeader) => {
  return [...defaultHeader]
    .sort((a, b) => a.columnNumber - b.columnNumber)
    .map((n) => n.columnName);
};

const roleSpecificColumnsInDrmBid = (
  columns,
  defaultHeader,
  customHeaders,
  //pageType,
  role
) => {

  //const defaultHeader = defaultColumnHeaders[pageType]?.columns;
  const orderedDefaultHeaderArray = orderHeaderArray(defaultHeader);

  const bookmarkedHeader = customHeaders?.find((column) => column.bookMarked);
  let filteredColumns;

  if (
    !bookmarkedHeader ||
    !bookmarkedHeader.columns ||
    bookmarkedHeader.columns.length === 0
  ) {
    filteredColumns = orderedDefaultHeaderArray
      .map((headerName) => columns.find((col) => col.Header === headerName))
      .filter(Boolean);
  } else {
    const orderedCustomHeaderArray = orderHeaderArray(bookmarkedHeader.columns);
    filteredColumns = orderedCustomHeaderArray
      .map((headerName) => columns.find((col) => col.Header === headerName))
      .filter(Boolean);
  }

  return filteredColumns;
};

const exportToExcel = (jasonData, fileName = "data") => {
  try {
    const workSheet = XLSX.utils.json_to_sheet(jasonData);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1");
    XLSX.writeFile(workBook, `${fileName}.xlsx`);
  } catch (error) {
    console.error("Excel export failed:", error);
  }
};

const snackBars = [
  {
    id: 1,
    severity: "info",
    autoHideDuration: 6000,
    datatestId: "download_started",
    message: "download_started",
    handleAccessor: 'download_started'
  },
  {
    id: 2,
    severity: "warning",
    autoHideDuration: 6000,
    datatestId: "export_in_progress",
    message: "export_in_progress",
    handleAccessor: 'export_in_progress'
  },
  {
    id: 3,
    severity: "warning",
    autoHideDuration: 6000,
    datatestId: "no_rec_to_download",
    message: "no_rec_to_download",
    handleAccessor: 'no_rec_to_download'
  },
  {
    id: 4,
    severity: "success",
    autoHideDuration: 6000,
    datatestId: "download_completed",
    message: "download_completed",
    handleAccessor: 'download_completed'
  },
];

const getCountriesWithUSFirst = (country) => {
  const usa = country?.find(c => c.countryCode === "USA");
  const others = country?.filter(c => c.countryCode !== "USA");
  return usa ? [usa, ...others] : others;
}

const splitAndTrim = (newValue) => {
   return newValue
          .split(",")
          .map((item) => item.trim())
          .filter((item) => item !== "");
}

const handlePaste = (e) => {
      e.preventDefault();
      
      try {
        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedText = clipboardData.getData("text");
        const sanitizedValue = pastedText.replace(/[^0-9.,;<>=!]/g, "");
        
        if (sanitizedValue) {
          const target = e.target;
          target.value = sanitizedValue;
          
          const inputEvent = new Event("input", { 
            bubbles: true, 
            cancelable: true 
          });
          target.dispatchEvent(inputEvent);
        }
      } catch (error) {
        console.warn("Paste operation failed:", error);
      }
    };

    const handleBeforeInput = (e) => {
     const allowedChars = /[0-9.,;<>=!]/;
      if (e.data && !allowedChars.test(e.data)) {
        e.preventDefault();
      }
    };

    const stringify = (value, key) => {
      if (Array.isArray(value)) {
      const labelConfig = DRMT_EXCEL_LABEL.find((entry) => entry.key === key);
      const valueKey = labelConfig?.value;
        return value
          .map((each) => (valueKey && each[valueKey] !== undefined ? each[valueKey] : ""))
          .filter(Boolean) 
          .join(", ");
      }

      return value != null ? String(value) : "";
    };

const formatErrorMessage = (key, params = {}) => {
  let message = i18n.t(key);
  
  Object.keys(params).forEach(param => {
    const placeholder = `{${param}}`;
    message = message.replace(new RegExp(placeholder, 'g'), params[param]);
  });
  
  return message;
};
///////////////////////////////////////////////
const parseLocalDate = (dateString) => {
  if (!dateString) return null;
  
  if (dateString.includes('/')) {
    const [month, day, year] = dateString.split('/');
    return new Date(year, month - 1, day);
  }
  
  if (dateString.includes('-')) {
    const [year, month, day] = dateString.split('-');
    return new Date(year, month - 1, day);
  }
  
  return null;
};

const getOneDayBefore = (date) => {
  const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  newDate.setDate(newDate.getDate() - 1);
  return newDate;
};

const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const DAILY_DEPENDENT_FIELDS = [
  "awardBackup",
  "qtyBucketType",
  "qtyActiveFlag",
  "minShipmentsAllocated",
  "maxShipmentsAllocated",
  "pctBucketType",
  "percentageActiveFlag",
  "pctAward",
];

const hasValidDailyCombination = (changedFlags, row) => {
  const comment = row?.changeComment === "-" ? null : row?.changeComment;
  const hasComment = Boolean(comment?.toString().trim());
  if (hasComment) {
    return true;
  }

    const effectiveChanged = changedFlags.effectiveDate === true;
    const expirationChanged = changedFlags.expirationDate === true;
    const baseRateChanged = changedFlags.rate === true || changedFlags.lineHaulRate === true;
    const dependentChanged = DAILY_DEPENDENT_FIELDS.some(
      (field) => changedFlags[field] === true
    );

    if (!effectiveChanged && !expirationChanged) {
      return false;
    }

    if (effectiveChanged && baseRateChanged) return true;
    if (effectiveChanged && expirationChanged && baseRateChanged) return true;
    if (effectiveChanged && dependentChanged) return true;
    if (expirationChanged && dependentChanged) return true;
    if (effectiveChanged && expirationChanged && dependentChanged) return true;

    return effectiveChanged || expirationChanged;
};

const buildDailyError = (key, params) => ({
  isError: true,
  errorMessage: formatErrorMessage(key, params),
  submitData: []
});

const mergeChangedFlags = (changes) =>
  changes.reduce((acc, change) => ({ ...acc, ...change }), {});

const extractDateContext = (origin, originalRecord) => ({
  newEffectiveDate: origin.effectiveDate ? parseLocalDate(origin.effectiveDate) : null,
  newExpireDate: origin.expirationDate ? parseLocalDate(origin.expirationDate) : null,
  oldEffectiveDate: originalRecord.effectiveDate ? parseLocalDate(originalRecord.effectiveDate) : null,
  oldExpireDate: originalRecord.expirationDate ? parseLocalDate(originalRecord.expirationDate) : null
});

const validateDailyCombination = (changedFields, origin) => {
  if (hasValidDailyCombination(changedFields, origin)) return null;
  return buildDailyError("daily_validation_invalid_change_combination", {
    sagaId: origin.sagaId
  });
};

const validateDateRules = (context, today, sagaId) => {
  const {
    isRateChanged,
    isEffectiveDateChanged,
    isExpireDateChanged,
    dates: { newEffectiveDate, newExpireDate, oldEffectiveDate, oldExpireDate }
  } = context;

  const validations = [
    {
      condition: isEffectiveDateChanged && newEffectiveDate && newEffectiveDate < today,
      key: "daily_validation_effective_date_past",
      params: { date: formatLocalDate(newEffectiveDate), sagaId }
    },
    {
      condition: isExpireDateChanged && newExpireDate && newExpireDate < today,
      key: "daily_validation_expiration_date_past",
      params: { date: formatLocalDate(newExpireDate), sagaId }
    },
    {
      condition: newEffectiveDate && newExpireDate && newEffectiveDate > newExpireDate,
      key: "daily_validation_effective_after_expiration",
      params: { sagaId }
    },
    {
      condition:
        isEffectiveDateChanged &&
        !isExpireDateChanged &&
        oldExpireDate &&
        newEffectiveDate &&
        newEffectiveDate > oldExpireDate,
      key: "daily_validation_effective_after_old_expiration",
      params: {
        newDate: formatLocalDate(newEffectiveDate),
        oldDate: formatLocalDate(oldExpireDate),
        sagaId
      }
    },
    {
      condition:
        isExpireDateChanged &&
        !isEffectiveDateChanged &&
        oldEffectiveDate &&
        newExpireDate &&
        newExpireDate < oldEffectiveDate,
      key: "daily_validation_expiration_before_old_effective",
      params: {
        newDate: formatLocalDate(newExpireDate),
        oldDate: formatLocalDate(oldEffectiveDate),
        sagaId
      }
    },
    {
      condition: isRateChanged && !isEffectiveDateChanged,
      key: "daily_validation_rate_requires_effective_date",
      params: { sagaId }
    }
  ];

  for (const check of validations) {
    if (check.condition) {
      return buildDailyError(check.key, check.params);
    }
  }

  if (
    isEffectiveDateChanged &&
    oldEffectiveDate &&
    newEffectiveDate &&
    newEffectiveDate < oldEffectiveDate
  ) {
    const oldDateInFuture = oldEffectiveDate > today;
    const newDateInFuture = newEffectiveDate > today;
    if (!(oldDateInFuture && newDateInFuture)) {
      return buildDailyError("daily_validation_effective_date_earlier_restriction", {
        oldDate: formatLocalDate(oldEffectiveDate),
        sagaId
      });
    }
  }

  return null;
};

const buildDailyRecords = (origin, originalRecord, context) => {
  const {
    isRateChanged,
    isEffectiveDateChanged,
    isExpireDateChanged,
    dates: { newEffectiveDate, newExpireDate }
  } = context;

  const records = [];
  const shouldSplitRecord =
    (!isRateChanged && isEffectiveDateChanged) ||
    (isRateChanged && isEffectiveDateChanged && originalRecord.status !== 3);

  const shouldExpireOnly =
    isExpireDateChanged && !isRateChanged && !isEffectiveDateChanged && originalRecord.status !== 3;

  if (shouldSplitRecord && newEffectiveDate) {
    const newExpireDateForOldRecord = getOneDayBefore(newEffectiveDate);
    records.push(
      {
        ...originalRecord,
        changeComment: origin.changeComment,
        expirationDate: formatToMMDDYYYY(formatLocalDate(newExpireDateForOldRecord)),
        status: 13
      },
      {
        ...origin,
        status: 16
      }
    );
    return records;
  }

  if (shouldExpireOnly && newExpireDate) {
    records.push({
      ...origin,
      expirationDate: formatToMMDDYYYY(formatLocalDate(newExpireDate)),
      status: 13
    });
    return records;
  }

  records.push({ ...origin });
  return records;
};

const processDailyRecord = (origin, originalRecord, changes, today) => {
  if (!changes || changes.length === 0) {
    return { isError: false, records: [] };
  }

  const changedFields = mergeChangedFlags(changes);
  const combinationError = validateDailyCombination(changedFields, origin);
  if (combinationError) {
    return combinationError;
  }

  const context = {
    isRateChanged: changedFields.rate === true,
    isEffectiveDateChanged: changedFields.effectiveDate === true,
    isExpireDateChanged: changedFields.expirationDate === true,
    dates: extractDateContext(origin, originalRecord)
  };

  const skipDateValidation = originalRecord.status === 3 && !context.isEffectiveDateChanged && !context.isExpireDateChanged;
  if (!skipDateValidation) {
    const dateError = validateDateRules(context, today, origin.sagaId);
    if (dateError) {
      return dateError;
    }
  }

  return {
    isError: false,
    records: buildDailyRecords(origin, originalRecord, context)
  };
};

const getDailyUpdatedPayload = (originalData, updatedData, selectedData) => {
  try {
    const submitData = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    for (const origin of selectedData) {
      const sagaId = origin.sagaId;
      const originalRecord = originalData.find((record) => record.sagaId === sagaId);

      if (!originalRecord) {
        return buildDailyError("daily_validation_original_record_not_found", { sagaId });
      }

      const changes = updatedData[sagaId];
      const result = processDailyRecord(origin, originalRecord, changes, today);

      if (result?.isError) {
        return result;
      }

      if (result.records?.length) {
        submitData.push(...result.records);
      }
    }

    return {
      isError: false,
      errorMessage: null,
      submitData
    };
  } catch (error) {
    return buildDailyError("daily_validation_processing_error", {
      error: error.message
    });
  }
};

const getFormattedTimestamp = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
};

const downloadZipFiles = (blobData, filename = `CEA_Profile-${getFormattedTimestamp()}`) => {
  const base64Data = blobData.data;
  
  const binaryString = window.atob(base64Data);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  
  const blob = new Blob([bytes], { type: "application/zip" });
  
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const primitiveToString = (value) => {
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return null;
};

const toSafeString = (value) => {
  if (value === undefined || value === null) return "";

  const primitive = primitiveToString(value);
  if (primitive !== null) {
    return primitive;
  }

  try {
    return String(value);
  } catch (error) {
    return "";
  }
};

const mapRateToChargeFields = (record) => {
  const rate = record?.rate ?? "";
  switch (record?.lineHaulChargeType) {
    case "BAF":
      return { baf: rate, civa: "", ets: "", lineHaulRate: "", rate: "" };
    case "CIVA":
      return { baf: "", civa: rate, ets: "", lineHaulRate: "", rate: "" };
    case "ETS":
      return { baf: "", civa: "", ets: rate, lineHaulRate: "", rate: "" };
    case "NA_FLAT":
    case "CONT":
      return { baf: "", civa: "", ets: "", lineHaulRate: rate };
    default:
      return { baf: "", civa: "", ets: "", lineHaulRate: "" };
  }
};

const modecreation = (tariffId) => {
  if (!tariffId || typeof tariffId !== "string") return "";
  const parts = tariffId.split("-");
  return parts.length >= 3 ? parts.slice(2).join("-") : "";
};

export {
  pageSize,
  defaultFilter,
  carrierRestrictedFilters,
  dateFormat,
  globalFiltersRequired,
  datetimeFormats,
  carrierRoles,
  carrierAndAnlystRoles,
  tmtRoles,
  absolutePaths,
  restrictedReasonCodes,
  eventType,
  lanes,
  globalFilters,
  restrictedColumnsPerformance,
  commentLimit,
  commentsFeature,
  browserTimezone,
  restrictedFilterChips,
  csvColumnMapping,
  responseConstList,
  stringToArray,
  getEnumValue,
  toHoursAndMinutes,
  roleSpecificColumns,
  isJsonParsable,
  generateGlobalFilters,
  generateTableFilters,
  optionalFiltersByTable,
  defaultHeaderFiltersByTable,
  isSubset,
  rejectNoResponseRestricted,
  renderRowComponentRestriction,
  restrictedPages,
  dateFormat1,
  getFloatValue,
  shouldDisableDate,
  formatToMMDDYYYY,
  parseFromDDMMYYYY,
  convertToMMDDYYYY,
  convertToDDMMYYYY,
  convertToYYYYDDMM,
  reorderColumns,
  roleSpecificColumnsInDrmBid,
  exportToExcel,
  snackBars,
  getCountriesWithUSFirst,
  splitAndTrim,
  TABLE_NAME,
  ACTIVE_FLAG,
  DOWNLOADED_FLAG,
  BUCKET_TYPE,
  AWARD_BACKUP_TYPE,
  STATUS,
  CATEGORY,
  STATUSCODE,
  REGION,
  CARRIER_MANAGER,
  ORDER_TYPE,
  PRE_AWARD,
  handlePaste,
  handleBeforeInput,
  stringify,
  DEFAULT_COMMON_COLUMN_VIEW,
  ADD_RECORD,
  defaultColumnHeaders,
  getDailyUpdatedPayload,
  formatErrorMessage,
  downloadZipFiles,
  primitiveToString,
  toSafeString,
  getCarrierEventResponseConfig,
  parseLocalDate,
  mapRateToChargeFields,
  modecreation
};
